import { Icon, IconButton, Modal, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';
import { Box, Button, Text, Modal as NBModal } from 'native-base';
import React, { useCallback, useState } from 'react';
import { useRecoilValue } from 'recoil';

import { useToastCreator } from '../../hooks/useToastCreator';
import { sessionState } from '../../store/session/atom';

const getFirstAndLastName = (fullName = '') => {
  const names = fullName.trim().split(' ');
  return {
    firstName: names[0] || '',
    lastName: names[names.length - 1] || '',
  };
};

export const InviteLinkModal = () => {
  const [isModalOpen, setModalOpen] = useState(true);
  const { userProfile } = useRecoilValue(sessionState);
  const { firstName, lastName } = getFirstAndLastName(userProfile?.nomeRecurso || '');
  const navigation = useNavigation();

  const { showToast } = useToastCreator('coppy-link-magico');

  const invitationLink = encodeURI(
    `https://wa.me/5511994438348?text=Quero criar minha conta Genial, com a indicação do(a) *${firstName} ${lastName}*. ID: *${userProfile?.idAssessorIntranet}*`
  );

  const handleCoppy = () => {
    navigator.clipboard
      .writeText(invitationLink)
      .then(() => {
        showToast('success', 'Tudo certo!', 'Link copiado para a área de transferência.', {
          duration: 3000,
        });
      })
      .catch(() => {
        showToast('error', 'Algo deu errado!', 'Link não copiado para a área de transferência.', {
          duration: 3000,
        });
      });
  };

  const goBack = useCallback(() => {
    setModalOpen(false);
    if (navigation.canGoBack()) {
      navigation.goBack();
    }
  }, [navigation]);

  return (
    <Modal isOpen={isModalOpen} onClose={goBack} testId="modal-invite-link">
      <NBModal.Content
        alignItems="center"
        w="full"
        maxW={{ base: 'full', lg: '540px' }}
        marginBottom={{ base: 0, lg: 'none' }}
        marginTop={{ base: 'auto', lg: 0 }}>
        <VStack
          alignItems={'flex-start'}
          p={Spacing['inline.xs']}
          w={{ base: 'full' }}
          bg={Color['neutral.white']}
          space={Spacing['inline.xxxs']}
          borderTopRadius={{ base: BoxRadius.md, lg: BoxRadius.sm }}>
          <HStack w="full" justifyContent="space-between">
            <Text variant="semibold" lineHeight={'distant'} fontSize={Typography['fontsize.lg']}>
              Gerar link para convite
            </Text>
            <IconButton
              testId="icon"
              icon="CloseModal"
              iconSize="xs"
              p={0}
              variant="rounded"
              borderWidth={0.05}
              backgroundColor="transparent"
              iconColor={Color['brand.primary.principal']}
              borderColor={Color['brand.primary.principal']}
              onPress={goBack}
            />
          </HStack>

          <Text variant="regular" lineHeight={'distant'} fontSize={Typography['fontsize.md']}>
            Convide novos clientes para se cadastrarem na Genial. Clique no botão abaixo para gerar
            um link de convite.
          </Text>
          <Box
            w={'full'}
            alignItems={'flex-start'}
            bg="background"
            borderRadius={BoxRadius.xs}
            py={Spacing['inset.nano']}>
            <VStack w={'full'} p={Spacing['inline.xxxs']}>
              <Text
                flex={1}
                variant="regular"
                lineHeight={'distant'}
                fontSize={Typography['fontsize.md']}>
                https://wa.me/5511994438348?text=Quero%20criar%20minha%20conta%20Genial%2C%20com%20a%20indica%C3%A7%C3%A3o%20do(a)%20
                <Text fontWeight="bold">{firstName}</Text>%20
                <Text fontWeight="bold">{lastName}</Text>.%20ID%3A%20
                <Text fontWeight="bold">{userProfile?.idAssessorIntranet}</Text>
              </Text>
            </VStack>
            <Button
              variant="textLink"
              onPress={handleCoppy}
              rightIcon={
                <Icon name="Copy" size="xxxs" color={Color['brand.tertiary.principal']} />
              }>
              Copiar
            </Button>
          </Box>
        </VStack>
      </NBModal.Content>
    </Modal>
  );
};
